var App = App || {};

App.Base = (function ($) {
    'use strict';

    function init() {
        AnchorSupport();
        $(window).on("hashchange", function (e) { AnchorSupport(); });
        //ZagParallaxExample();
        //ZagScrollAnimateExample();
    }

    function AnchorSupport() {

        var Hash = $(location.hash);

        if (Hash.length == 1) {

            if (Hash.attr("data-bs-toggle") == "collapse") {
                var Target = $(Hash.attr("data-bs-target"));
                var Panel = document.getElementById(Target.attr("id"));
                var Collapse = new bootstrap.Collapse(Panel);
                Collapse.show();

                // BS5 collapse methods don't seem to intersect with how accordions are promised to work
                // Look for and close collapses within the same accordion
                var SiblingTarget = Target.parents(".accordion").find(".collapse.show");
                var SiblingPanel = document.getElementById(SiblingTarget.attr("id"));
                var SiblingCollapse = new bootstrap.Collapse(SiblingPanel);
                SiblingCollapse.hide();
            }

            else if (Hash.attr("data-bs-toggle") == "tab") {
                var Panel = document.getElementById(Hash.attr("id"));
                var Tab = new bootstrap.Tab(Panel);
                Tab.show();
            }
        }
    }

    //function ZagParallaxExample() {
    //    $(".page-masthead .page-masthead-image").ZagParallax({ divisor: 2 });
    //}

    //function ZagScrollAnimateExample() {

    //    $(".page-masthead").ZagScrollAnimate({
    //        offset: 75,
    //        targets: [
    //            { selector: ".page-masthead-title", type: "animate__fadeInLeft", stagger: 0 },
    //            { selector: ".page-masthead-rich-text", type: "animate__fadeInRight", stagger: 0 },
    //            { selector: ".page-masthead-ctas > ul > li", type: "animate__fadeInUp", stagger: 200 }
    //        ]
    //    });
    //}

    // https://davidwalsh.name/query-string-javascript
    function GetUrlParameter(name) {
        name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
        var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
        var results = regex.exec(location.search);
        return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    };

    return {
        init: init,
        GetUrlParameter: GetUrlParameter
    };

})(jQuery);

$(function () {
    App.Base.init();
});